import { Divider } from "../../components/divider/divider.tsx";
import { FontStyles } from "../../utils/font-styles.ts";
import { SectionHeader } from "../../components/section-header.tsx";
import { focusStylesOutline } from "../../utils/focus-styles.ts";

export interface SocialMediaBoxProps {
  sectionImageUrl?: string;
  sectionImageHighResUrl?: string;
  urls: { url: string; platform: SocialMediaPlatform }[];
  headerText?: string;
}

export type SocialMediaPlatform = "Facebook" | "LinkedIn" | "Instagram" | "YouTube" | "X" | "TikTok";

type SocialMediaLinksMeta = Record<
  SocialMediaPlatform,
  {
    text: string;
    icon: string;
  }
>;

const socialMediaLinksMeta: SocialMediaLinksMeta = {
  Facebook: {
    text: "Facebook",
    icon: "/static/icons/facebook-social-icon.svg",
  },
  LinkedIn: {
    text: "LinkedIn",
    icon: "/static/icons/linkedin-social-icon.svg",
  },
  Instagram: {
    text: "Instagram",
    icon: "/static/icons/instagram-social-icon.svg",
  },
  YouTube: {
    text: "YouTube",
    icon: "/static/icons/youtube-social-icon.svg",
  },
  X: {
    text: "X / Twitter",
    icon: "/static/icons/x-social-icon.svg",
  },
  TikTok: {
    text: "TikTok",
    icon: "/static/icons/tiktok-social-icon.svg",
  },
};

const outerContainerClassName = "flex flex-col gap-2.5 w-full max-w-[400px] mx-auto md:max-w-[1024px] lg:max-w-[350px]";

const mainContainerClassName =
  "flex flex-col md:flex-row lg:flex-col " +
  "shadow-espc bg-cloud border border-foggy-firth rounded-md overflow-hidden";

export const SocialMediaBox = (props: SocialMediaBoxProps) => {
  if (props.urls.length === 0) {
    return null;
  }
  return (
    <div className={outerContainerClassName}>
      {props.headerText && (
        <SectionHeader
          text={props.headerText}
          className={`leading-none md:leading-none ${FontStyles.h5}`}
        ></SectionHeader>
      )}
      <div className={mainContainerClassName}>
        {props.sectionImageUrl && props.sectionImageHighResUrl && (
          <img
            className="object-contain max-h-[350px] w-[400px]"
            src={props.sectionImageUrl}
            srcSet={`${props.sectionImageHighResUrl} 2x`}
            alt="Image above social media"
          />
        )}
        {props.urls.length > 0 && (
          <div className="flex flex-col gap-3 p-3.5 md:p-5 grow justify-center">
            {props.urls.map((socialLink, index) => [
              <a
                href={socialLink.url}
                key={socialLink.platform}
                className={`block flex gap-3 items-center ${focusStylesOutline}`}
              >
                <img
                  src={socialMediaLinksMeta[socialLink.platform].icon}
                  alt={`${socialLink.platform} icon`}
                  className="h-6"
                />
                <span className={`${FontStyles["body-l"]} leading-none md:leading-none`}>
                  {socialMediaLinksMeta[socialLink.platform].text}
                </span>
              </a>,
              index + 1 < props.urls.length ? <Divider key={index} /> : null,
            ])}
          </div>
        )}
      </div>
    </div>
  );
};
